import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { setPurchasePopupAnchor } from '../../utils/purchasePopupAnchor';
export function SplitShell(props) {
    const { isSidebarOpen = false, isLeftSidebarOpen = false, className, children = _jsx("div", {}), sidebar = _jsx("div", {}), leftSidebar, } = props;
    const setRootElementRef = useCallback((el) => {
        setPurchasePopupAnchor((isSidebarOpen && el) || undefined);
    }, [isSidebarOpen]);
    return (_jsxs(_Fragment, { children: [_jsx(SidebarGlobals, {}), _jsxs(SplitShellRoot, { ref: setRootElementRef, className: className, "$isSidebarOpen": isSidebarOpen, "$isLeftSidebarOpen": isLeftSidebarOpen, children: [leftSidebar && _jsx(LeftSidebar, { children: leftSidebar }), _jsx(Main, { children: children }), _jsx(Sidebar, { children: sidebar })] })] }));
}
const SidebarGlobals = createGlobalStyle `
    @media (min-width: 60rem) {
        body {
            --Sidebar_DesktopWidth: 25.25rem;
            --LeftSidebar_DesktopWidth: 15rem;
        }
    }
`;
const LeftSidebar = styled.div `
    width: var(--LeftSidebar_DesktopWidth, 0);
    top: 0;
    left: 0;
    height: 100%;
    position: absolute;
    transition: 250ms ease-in-out;
    transition-property: visibility, opacity, transform;
    transition-delay: 250ms, 0s, 0s;
`;
const Sidebar = styled.div `
    width: var(--Sidebar_DesktopWidth, 0);
    top: 0;
    right: 0;
    height: 100%;
    position: absolute;
    transition: 250ms ease-in-out;
    transition-property: visibility, opacity, transform;
    transition-delay: 250ms, 0s, 0s;
`;
const Main = styled.div `
    height: 100%;
    position: absolute;
    inset: 0;
    transition: 250ms ease-in-out;
    transition-property: left, right;
`;
const SplitShellRoot = styled.div `
    height: 100%;
    position: relative;

    ${LeftSidebar} {
        transform: translateX(-100%);
        opacity: 0;
        visibility: hidden;
    }

    ${Sidebar} {
        transform: translateX(100%);
        opacity: 0;
        visibility: hidden;
    }

    ${Main} {
        left: 0;
        right: 0;
    }

    ${({ $isLeftSidebarOpen = false }) => $isLeftSidebarOpen &&
    css `
            @media (min-width: 60rem) {
                ${LeftSidebar} {
                    transform: translateX(0);
                    opacity: 1;
                    visibility: visible;
                    transition-delay: 0s;
                }

                ${Main} {
                    left: var(--LeftSidebar_DesktopWidth, 0);
                }
            }
        `}

    ${({ $isSidebarOpen = false }) => $isSidebarOpen &&
    css `
            @media (min-width: 60rem) {
                ${Sidebar} {
                    transform: translateX(0);
                    opacity: 1;
                    visibility: visible;
                    transition-delay: 0s;
                }

                ${Main} {
                    right: var(--Sidebar_DesktopWidth, 0);
                }
            }
        `}
`;
